<div class="container container-full-page">
  <h1>
    Help
  </h1>

  <p>
    Support is available Monday to Friday 8am to 6pm AEST (excluding Public Holidays).
  </p>

  <div class="table-responsive">
    <table class="table table-striped">
      <thead>
        <tr>
          <th scope="col">Type</th>
          <th scope="col">Contact</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <th scope="row">
            Login & Product - includes issues with Vision Insights
          </th>
          <td>
            Contact your Vision Insights System expert or Client Service Manager.
          </td>
        </tr>
        <tr>
          <th scope="row">
            Technical - includes network issues, Browser issues, etc.
          </th>
          <td>
            Phone +61 2 9036 6630 to speak to a support representative
            <br>
            Email: Business.Solutions&#64;au.knightfrank.com
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <h4>
    System recommendations
  </h4>

  <p>
    To access Vision Insights, you will need to make sure your computer has appropriate hardware, software and screen resolution
    to
    run an up-to-date browser.
  </p>

  <p>
    Supported browers can be downloaded from these links:
  </p>

  <ul>
    <li>
      <a href="https://support.google.com/chrome/answer/95346?co=GENIE.Platform%3DDesktop&hl=en-GB">Google Chrome™</a>
    </li>
    <li>
      <a href="https://www.mozilla.org/en-US/firefox/new/">Mozilla Firefox©</a>
    </li>
    <li>
      Apple Safari™ (pre-installed)
    </li>
    <li>
      <a href="https://www.microsoft.com/en-us/edge">Microsoft Edge®</a>
    </li>
  </ul>

  <p>
    Knight Frank is dedicated to providing the best solutions for the property industry.
  </p>
</div>
